// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".back-link[data-v-64883ba2]{align-items:center;display:flex;font-size:16px;margin-bottom:10px;outline:0;padding:10px 0;width:-moz-fit-content;width:fit-content}", ""]);
// Exports
module.exports = exports;
